import { animateEffectSubject, animateTarget, findEffect, isMotionValue, visualElementStore, } from "motion-dom";
import { invariant } from "motion-utils";
import { createDOMVisualElement, createObjectVisualElement, } from "../utils/create-visual-element";
import { isDOMKeyframes } from "../utils/is-dom-keyframes";
import { resolveSubjects } from "./resolve-subjects";
import { animateSingleValue } from "motion-dom";
function isSingleValue(subject, keyframes) {
    return (isMotionValue(subject) ||
        typeof subject === "number" ||
        (typeof subject === "string" && !isDOMKeyframes(keyframes)));
}
/**
 * Implementation
 */
export function animateSubject(subject, keyframes, options, scope) {
    const animations = [];
    if (isSingleValue(subject, keyframes)) {
        animations.push(animateSingleValue(subject, isDOMKeyframes(keyframes)
            ? keyframes.default || keyframes
            : keyframes, options ? options.default || options : options));
    }
    else {
        // Gracefully handle null/undefined subjects (e.g., from querySelector returning null)
        if (subject == null) {
            return animations;
        }
        const subjects = resolveSubjects(subject, keyframes, scope);
        const numSubjects = subjects.length;
        invariant(Boolean(numSubjects), "No valid elements provided.", "no-valid-elements");
        for (let i = 0; i < numSubjects; i++) {
            const thisSubject = subjects[i];
            const transition = { ...options };
            /**
             * Resolve stagger function if provided.
             */
            if ("delay" in transition &&
                typeof transition.delay === "function") {
                transition.delay = transition.delay(i, numSubjects);
            }
            const isElement = thisSubject instanceof Element;
            /**
             * Registered effects (animate.addEffect) claim non-DOM subjects
             * before we fall back to treating them as plain objects.
             */
            const effect = isElement ? undefined : findEffect(thisSubject);
            if (effect) {
                animations.push(...animateEffectSubject(effect, thisSubject, keyframes, transition));
                continue;
            }
            const createVisualElement = isElement
                ? createDOMVisualElement
                : createObjectVisualElement;
            if (!visualElementStore.has(thisSubject)) {
                createVisualElement(thisSubject);
            }
            const visualElement = visualElementStore.get(thisSubject);
            animations.push(...animateTarget(visualElement, { ...keyframes, transition }, {}));
        }
    }
    return animations;
}
//# sourceMappingURL=subject.js.map